/*
 * KT Cloud MarketPlace BackOffice version 1.0
 *
 *  Copyright ⓒ 2022 kt corp. All rights reserved.
 *
 *  This is a proprietary software of kt corp, and you may not use this file except in
 *  compliance with license agreement with kt corp. Any redistribution or use of this
 *  software, with or without modification shall be strictly prohibited without prior written
 *  approval of kt corp, and the copyright notice above does not evidence any actual or
 *  intended publication of such software.
 */
import moment from 'moment'

export const staLogin = {
    namespaced: true,
    state: {
        loginId: '',
        accessToken: '',
        managerName: '',
        managerEmail: '',
        managerPhone: '',
        codeId: 'PUBLIC_COMPANY',
        uuid: '',
        deviceOS: 'BO',
        companyNm: '',
        loginTime: moment().format('YYYY년MM월DD일 hh:mm'),
        memSq  : '',
        localPayId: '',
        comCode: '',
        companyId: '',
        loginPopup : false,
        // 암호화
        pke: '',
        pkm: '',
        publicKey: '',

        // 법정 동코드 / 지역명 추가
        areaName: '',
        addrCode: '',
        addrCodeBasic: '',
        addrAreaBasic: '',
        firstPwdYn: '',
        loginChekcTime: moment().format('YYYY-MM-DD- hh:mm'),
        expireTime: "",
        monthPwdYn: "",
        redirect : "",
        salesMaterialYn : ""
    },

    mutations: {
        setId(state, payload) {
            state.loginId = payload
        },
        setLoginPopup(state, payload) {
            state.loginPopup = payload
        },
        setMemSq(state, payload) {
            state.memSq = payload
        },
        setManagerName(state, payload) {
            state.managerName = payload
        },
        setEmail(state, payload) {
            state.managerEmail = payload
        },
        setToken(state, payload) {
            state.accessToken = payload
        },
        setPartnerAccessToken(state, payload) {
            state.accessToken = payload
        },
        setLoginChekcTime(state, payload) {
            state.loginChekcTime = payload
        },

        setLoginTime(state, payload) {
            state.loginTime = payload
        },
        
        setcompanyId(state, payload) {
            state.companyId = payload
        },
        setCompanyNm(state, payload) {
            state.pubCompanyNm = payload
        },
        
        setAddrName(state, payload) {
            state.areaName = payload
        },
        setAddrCode(state, payload) {
            state.addrCode = payload
        },

        setBasicAddrName(state, payload) {
            state.addrAreaBasic = payload
        },
        setBasicAddrCode(state, payload) {
            state.addrCodeBasic = payload
        },
        setLocalComCode(state, payload) {
            state.comCode = payload
        },
        setLocalCompanyId(state, payload) {
            state.companyId = payload
        },

        setPke(state, payload) {
            state.pke = payload
        },
        setPkm(state, payload) {
            state.pkm = payload
        },
        setPublicKey(state, payload) {
            state.publicKey = payload
        },
        setFirstPwdYn(state, payload) {
            state.firstPwdYn = payload
        },

        //토큰 만료시간
        setExpireTime(state, payload) {
            state.expireTime = payload
        },

        //6개월 패스워드  
        setMonthPwdYn(state, payload) {
            state.monthPwdYn = payload
        },

        setRedirect(state, payload) {
            state.redirect = payload
        },
        setSalesMaterialYn(state, payload) {
            state.salesMaterialYn = payload
        },
        
    },

    actions: {
        saveId({ state, commit }, payload) {
            commit('setId', payload)
        },
        saveToken({ }) {

        }
    },

    getters: {
        getLoginId(state) { return state.loginId },
        getLoginPopup(state) { return state.loginPopup },
        getMemSq(state) { return state.memSq },
        getCompanyId(state) { return state.companyId },
        getCompanyNm(state) { return state.companyNm },
        
        getManagerName(state) { return state.managerName },
        getEmail(state) { return state.managerEmail },
        getPartnerAccessToken(state) { return state.accessToken },
        loginTime(state) { return state.loginTime },
        
        getUserToken(state) {
            return { "mdn": state.managerPhone, "deviceOS": state.deviceOS, "managerId": state.loginId }
        },
        getHeaderId(state) {
            return { "adminId": state.loginId }
        },
        getCompany(state) {
            return { "adminId": state.loginId, "codeId": state.codeId }
        },

        getLocalComCode(state) { return state.comCode },
        getLocalCompanyId(state) { return state.companyId },

        // 암호화 데이터
        getPke(state) { return state.pke },
        getPkm(state) { return state.pkm },
        getPublicKey(state) { return state.publicKey },

        //법정 동코드 /지역명 추가
        getAddrName(state) { return state.areaName },
        getAddrCode(state) { return state.addrCode },
        getBasicAddrName(state) { return state.addrAreaBasic },
        getBasicAddrCode(state) { return state.addrCodeBasic },

        //최초 접속시 패스워드 변
        getFirstPwdYn(state) { return state.firstPwdYn },
        getLoginChekcTime(state) { return state.loginChekcTime },
        //토큰 만료시간
        getExpireTime(state) { return state.expireTime },
        getMonthPwdYn(state) { return state.monthPwdYn },
        getRedirect(state) { return state.redirect },
        getSalesMaterialYn(state) { return state.salesMaterialYn },
        
    }
};